<template>
  <InputFrame>
    <Flex items-center :class="classes" class="h-full">
      <slot name="pre-icon" />
      <div class="px-2 grow border-none bg-none text-gray-700 overflow-hidden">
        <slot name="input" />
      </div>
      <slot name="pos-icon" />
    </Flex>
  </InputFrame>
</template>

<script setup>
import { computed } from 'vue'

// Props
const props = defineProps({
  error: [Boolean, Array],
  disabled: Boolean,
})
// Computed
const classes = computed(() => ({
  'border-red-500': props.error,
  'border-slate-300': !props.error,
  'text-red-500': props.error,
  'bg-slate-200': props.disabled,
}))
</script>
